(function () {
  if (window.__spsQuickBuyBound) return;
  window.__spsQuickBuyBound = true;

  var COLOR_HEX = {
    "Black / Dark Teal": "#17506b",
    "Pink / Pink": "#f7b8cd",
    "Aqua / Black": "#bfe8dc"
  };

  var selectedVariantId = null;
  var qty = 1;

  function moneyHtml(value) {
    if (value == null || value === "" || value === "—") return "—";
    var text = String(value);
    if (text.indexOf('class="money"') !== -1 || text.indexOf("class='money'") !== -1 || text.indexOf("class=money") !== -1) {
      return text;
    }
    return '<span class="money">' + text + "</span>";
  }

  function setMoneyEl(el, value) {
    if (!el) return;
    var html = moneyHtml(value);
    if (html === "—") el.textContent = "—";
    else el.innerHTML = html;
  }

  function productsEl() {
    return document.querySelector("[data-sps-products]");
  }

  function loadProducts() {
    var el = productsEl();
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return {};
    }
  }

  function modalEl() {
    return document.getElementById("spsQuickBuy");
  }

  function mountModal() {
    var modal = modalEl();
    if (modal && modal.parentElement !== document.body) {
      modal.classList.add("sps");
      document.body.appendChild(modal);
    }
    return modalEl();
  }

  function openQuickBuy(key) {
    var modal = mountModal();
    if (!modal) return;

    var titleEl = document.getElementById("spsQbTitle");
    var fitsEl = document.getElementById("spsQbFits");
    var swatchesEl = document.getElementById("spsQbSwatches");
    var qtyEl = document.getElementById("spsQbQty");
    var priceEl = document.getElementById("spsQbPrice");
    var addBtn = document.getElementById("spsQbAdd");
    if (!titleEl || !fitsEl || !swatchesEl || !qtyEl || !priceEl || !addBtn) return;

    var catalog = loadProducts();
    var product = catalog[key] || {};
    selectedVariantId = null;
    qty = 1;
    qtyEl.textContent = qty;
    titleEl.textContent = product.title || "—";
    fitsEl.textContent = product.fits || "";
    setMoneyEl(priceEl, "—");
    addBtn.disabled = true;
    addBtn.textContent = "Select a colour";

    swatchesEl.innerHTML = "";
    var variants = product.variants || [];
    variants.forEach(function (v) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "sps-qb__swatch";
      if (!v.available) btn.disabled = true;
      var dot = document.createElement("span");
      dot.className = "dot";
      dot.style.background = COLOR_HEX[v.color] || "#ccc";
      btn.appendChild(dot);
      btn.appendChild(document.createTextNode(v.color || "Option"));
      btn.addEventListener("click", function () {
        selectedVariantId = v.id;
        Array.prototype.forEach.call(swatchesEl.children, function (b) {
          b.classList.toggle("on", b === btn);
        });
        setMoneyEl(priceEl, v.price_html);
        addBtn.disabled = false;
        addBtn.textContent = "Add to cart";
      });
      swatchesEl.appendChild(btn);
    });

    if (!variants.length) {
      addBtn.textContent = "Product unavailable";
    }

    modal.classList.add("on");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeQuickBuy() {
    var modal = modalEl();
    if (!modal) return;
    modal.classList.remove("on");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  document.addEventListener("click", function (e) {
    var buyBtn = e.target.closest("[data-quickbuy]");
    if (buyBtn) {
      e.preventDefault();
      openQuickBuy(buyBtn.getAttribute("data-quickbuy"));
      return;
    }
    if (e.target.closest("[data-qb-close]")) {
      closeQuickBuy();
      return;
    }
    var qtyBtn = e.target.closest("[data-qb-qty]");
    if (qtyBtn && modalEl() && modalEl().contains(qtyBtn)) {
      var delta = parseInt(qtyBtn.getAttribute("data-qb-qty"), 10);
      qty = Math.max(1, Math.min(10, qty + delta));
      var qtyEl = document.getElementById("spsQbQty");
      if (qtyEl) qtyEl.textContent = qty;
      return;
    }
    if (e.target.id === "spsQbAdd" || (e.target.closest && e.target.closest("#spsQbAdd"))) {
      var addBtn = document.getElementById("spsQbAdd");
      if (!addBtn || addBtn.disabled || !selectedVariantId) return;
      addBtn.disabled = true;
      addBtn.textContent = "Adding…";
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      fetch(root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: qty }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error("add failed");
          return res.json();
        })
        .then(function () {
          window.location.href = root + "checkout";
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = "Something went wrong — try again";
        });
    }
  });

  document.addEventListener("keydown", function (e) {
    var modal = modalEl();
    if (e.key === "Escape" && modal && modal.classList.contains("on")) closeQuickBuy();
  });

  function initPricingAndCarousels() {
    if (window.__spsPricingBound) return;
    window.__spsPricingBound = true;

    var CONFIG = {
      launchLabel: "Launch day — Oct 7",
      tiers: [
        { pct: 20, until: "2026-08-31", label: "August" },
        { pct: 15, until: "2026-09-30", label: "September" }
      ]
    };

    function endOf(d) {
      return new Date(d + "T23:59:59");
    }
    function currentTierIndex(now) {
      for (var i = 0; i < CONFIG.tiers.length; i++) {
        if (now <= endOf(CONFIG.tiers[i].until)) return i;
      }
      return -1;
    }
    function fmt(ms) {
      if (ms < 0) ms = 0;
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;
      return (
        d +
        "d " +
        String(h).padStart(2, "0") +
        "h " +
        String(m).padStart(2, "0") +
        "m " +
        String(sec).padStart(2, "0") +
        "s"
      );
    }
    function setAll(sel, txt) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.textContent = txt;
      });
    }
    function renderTiers(idx) {
      var box = document.getElementById("spsTiers");
      if (!box) return;
      var html = "";
      CONFIG.tiers.forEach(function (t, i) {
        var cls = i === idx ? "active" : idx === -1 || i < idx ? "past" : "";
        html +=
          '<div class="row ' +
          cls +
          '"><span>' +
          t.label +
          (i === idx ? " — <strong>you are here</strong>" : "") +
          "</span><span>" +
          t.pct +
          "% off</span></div>";
      });
      html +=
        '<div class="row' +
        (idx === -1 ? " active" : "") +
        '"><span>' +
        CONFIG.launchLabel +
        "</span><span>Full price</span></div>";
      box.innerHTML = html;
    }
    function tick() {
      var now = new Date();
      var idx = currentTierIndex(now);
      if (idx === -1) {
        setAll(".sps-price-inline", "order now");
        var bar = document.getElementById("spsBar");
        if (bar) bar.innerHTML = "🎉 The Strapsicle iPad case has launched — now shipping!";
        setAll("#spsNextRise", "now shipping");
        setAll(".sps-final-timer", "—");
        renderTiers(-1);
        return;
      }
      var t = CONFIG.tiers[idx];
      var timer = fmt(endOf(t.until) - now);
      setAll(".sps-save-pct", t.pct + "%");
      setAll(".sps-price-inline", "save " + t.pct + "%");
      var barPct = document.getElementById("spsBarPct");
      if (barPct) barPct.textContent = t.pct + "% OFF";
      var barTimer = document.getElementById("spsBarTimer");
      if (barTimer) barTimer.textContent = timer;
      var next = document.getElementById("spsNextRise");
      if (next) next.textContent = "next price rise in " + timer;
      setAll(".sps-final-timer", timer);
      renderTiers(idx);
    }

    tick();
    setInterval(tick, 1000);

    document.querySelectorAll(".sps-carousel").forEach(function (car) {
      if (car.getAttribute("data-sps-ready")) return;
      car.setAttribute("data-sps-ready", "true");
      var figs = Array.prototype.slice.call(car.querySelectorAll("figure"));
      var dots = car.querySelector(".sps-cdots");
      var prev = car.querySelector(".prev");
      var next = car.querySelector(".next");
      if (!dots || !prev || !next || !figs.length) return;
      var i = Math.max(
        0,
        figs.findIndex(function (f) {
          return f.classList.contains("on");
        })
      );
      figs.forEach(function (_, n) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", "Show color " + (n + 1));
        b.addEventListener("click", function () {
          go(n);
        });
        dots.appendChild(b);
      });
      function go(n) {
        i = (n + figs.length) % figs.length;
        figs.forEach(function (f, k) {
          f.classList.toggle("on", k === i);
        });
        Array.prototype.forEach.call(dots.children, function (d, k) {
          d.classList.toggle("on", k === i);
        });
      }
      prev.addEventListener("click", function () {
        go(i - 1);
      });
      next.addEventListener("click", function () {
        go(i + 1);
      });
      go(i);
    });
  }

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    mountModal();
    initPricingAndCarousels();
  });
  document.addEventListener("shopify:section:load", mountModal);
})();
